/**
 * LOCALES STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    onlyCountries: ["US", "JP", "CA", "MX", "NZ", "DE", "IN", "BR", "FR"],
};

// getters
const getters = {
    locale_loader: (state) => (id) => {
        alert(id);
        return state.locale_loader;
    },
    states: (state) => {
        return state.states;
    },
    countries: (state) => {
        return state.countries;
    },
    postal_code: (state) => {
        return state.postal_code;
    },
    onlyCountries: (state) => {
        return state.onlyCountries;
    },
};

// actions
const actions = {
    async fetchLocale({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (payload.commit) {
                    commit("mutateLocale", {
                        property: payload.stateProperty,
                        with: response.data[payload.stateProperty],
                    });
                }
                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    mutateLocale(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
